import { $getSelection, $isRangeSelection } from 'lexical';
import { useEffect } from 'react';
const TYPEAHEAD_ACTIVATION_UPDATE_TAG = 'typeahead-activate';
/**
 * Show suggestions for a restored draft without waiting for another keystroke.
 * The draft can arrive before the menu is ready, so check it again once the menu starts listening.
 * Marking the selection for an update makes Lexical run this check without editing the draft.
 * The tag identifies this extra update when debugging.
 */
export function useTypeaheadActivation({ editor, enabled, markerActiveRef, }) {
    useEffect(() => {
        if (!enabled || markerActiveRef.current)
            return;
        editor.update(() => {
            const selection = $getSelection();
            if ($isRangeSelection(selection)) {
                selection.dirty = true;
            }
        }, { tag: TYPEAHEAD_ACTIVATION_UPDATE_TAG });
    }, [editor, markerActiveRef, enabled]);
}
//# sourceMappingURL=useTypeaheadActivation.js.map